import script from "./configurationOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./configurationOverview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__